<div class="shell">
  @if (navLoading()) {
    <mat-progress-bar
      class="shell__nav-progress"
      mode="indeterminate"
      aria-label="Loading"
    ></mat-progress-bar>
  }
  <header class="shell__topbar">
    <a class="shell__brand" routerLink="/" aria-label="Home">
      <img class="shell__brand-logo shell__brand-logo--horizontal-light" src="logos/vitails-horizontal-colour.svg" alt="ViTails" />
      <img class="shell__brand-logo shell__brand-logo--horizontal-dark" src="logos/vitails-horizontal-white.svg" alt="ViTails" />
      <img class="shell__brand-logo shell__brand-logo--mono-light" src="logos/vitails-monogram-colour.svg" alt="ViTails" />
      <img class="shell__brand-logo shell__brand-logo--mono-dark" src="logos/vitails-monogram-white.svg" alt="ViTails" />
      <span class="shell__brand-text">ViTails</span>
      @if (practiceName()) {
        <span class="shell__practice">· {{ practiceName() }}</span>
      }
    </a>

    <nav class="shell__desktopnav">
      @for (tab of visibleTabs(); track trackByRoute($index, tab)) {
        <a
          class="desktop-tab"
          [routerLink]="tab.route"
          routerLinkActive="desktop-tab--active"
          [routerLinkActiveOptions]="{ exact: tab.exact }"
          >
          <span>{{ tab.label }}</span>
        </a>
      }
    </nav>

    <app-branch-picker class="shell__branch-picker"></app-branch-picker>

    <button
      mat-icon-button
      class="shell__user-btn"
      [matMenuTriggerFor]="userMenu"
      aria-label="User menu"
      >
      @if (photoURL(); as url) {
        <img class="shell__user-avatar" [src]="url" alt="User" />
      } @else {
        <mat-icon>account_circle</mat-icon>
      }
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before" class="user-menu-panel">
      <div class="user-menu__header" mat-menu-item disabled>
        <mat-icon>person</mat-icon>
        <span>{{ displayName() }}</span>
      </div>

      <!-- USER section -->
      <div class="user-menu__group-label" mat-menu-item disabled>User</div>
      <button mat-menu-item (click)="openSettings()">
        <mat-icon>settings</mat-icon>
        <span>Settings</span>
      </button>

      <!-- PRACTICE section -->
      @if (hasAnyPracticeMenu()) {
        <mat-divider></mat-divider>
        <div class="user-menu__group-label" mat-menu-item disabled>Practice</div>
        @if (canSeePracticeSettings()) {
          <button mat-menu-item (click)="openPracticeSettings()">
            <mat-icon>tune</mat-icon>
            <span>Practice Settings</span>
          </button>
        }
        @if (canSeeTeam()) {
          <button mat-menu-item (click)="openTeam()">
            <mat-icon>group</mat-icon>
            <span>Team</span>
          </button>
        }
        @if (canSeeLibrary()) {
          <button mat-menu-item (click)="openLibrary()">
            <mat-icon>library_books</mat-icon>
            <span>Practice Library</span>
          </button>
        }
        @if (canSeeAuditLog()) {
          <button mat-menu-item (click)="openAuditLog()">
            <mat-icon>history</mat-icon>
            <span>Activity Log</span>
          </button>
        }
        @if (canSeeSubscription()) {
          <button mat-menu-item (click)="openManageSubscription()">
            <mat-icon>credit_card</mat-icon>
            <span>Subscription</span>
          </button>
        }
      }

      <!-- SESSION section -->
      <mat-divider></mat-divider>
      <div class="user-menu__group-label" mat-menu-item disabled>Session</div>
      <button mat-menu-item (click)="switchPractice()">
        <mat-icon>swap_horiz</mat-icon>
        <span>Switch Practice</span>
      </button>
      <button mat-menu-item (click)="signOut()">
        <mat-icon>logout</mat-icon>
        <span>Sign Out</span>
      </button>
    </mat-menu>
  </header>
  <main class="shell__content" #scrollContainer>
    <app-subscription-banner />
    <router-outlet />
  </main>

  <nav class="shell__bottomnav">
    @for (tab of visibleTabs(); track trackByRoute($index, tab)) {
      <button
        type="button"
        class="bottomnav__tile"
        [class.bottomnav__tile--active]="isTabActive(tab)"
        (click)="onTabTap(tab)"
        >
        <mat-icon>{{ tab.icon }}</mat-icon>
        <span>{{ tab.mobileLabel ?? tab.label }}</span>
      </button>
    }
  </nav>
</div>
